import { motion } from "framer-motion";

const ease = [0.16, 1, 0.3, 1];

export function Reveal({ children, delay = 0, y = 28, className = "", as = "div", id }) {
  const M = motion[as] || motion.div;
  return (
    <M
      id={id}
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.9, ease, delay }}
    >
      {children}
    </M>
  );
}

// Kinetic masked line-by-line reveal for hero
export function MaskLines({ lines, className = "", delay = 0 }) {
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden">
          <motion.span
            className="block"
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 1, ease, delay: delay + i * 0.12 }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
}

export function Stat({ value, label, delay = 0 }) {
  return (
    <Reveal delay={delay} className="border-l border-border pl-5">
      <div className="font-display text-4xl sm:text-5xl font-medium tracking-tighter">{value}</div>
      <div className="mt-2 font-mono text-xs uppercase tracking-[0.2em] text-muted-foreground">{label}</div>
    </Reveal>
  );
}
